import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map, withLatestFrom } from 'rxjs/operators';
import { isFeatureFlagEnabled } from 'src/app/store/feature-flags/feature-flags.selectors';
import { AppStore } from 'src/app/store/store.model';

@Injectable({ providedIn: 'root' })
export class FeatureFlagFilterOperatorService {
  constructor(private store$: Store<AppStore>) {}
  /**
   * Filters the source stream based on the provided feature flag
   *
   * - If the flag is falsy/empty, no filtering will occur
   * - If the flag is enabled the item will be emitted, otherwise it will be filtered out
   *
   * Used to conditionally enable effects based on feature flags
   * @param flagName feature flag name from Launch Darkly
   */
  public filter<TActionProps>(flagName: string) {
    return (source$: Observable<TActionProps>) =>
      !flagName
        ? source$ // return source unfiltered if no flag name provided
        : source$.pipe(
            withLatestFrom(this.store$.select(isFeatureFlagEnabled(flagName))),
            filter(([, enabled]) => enabled),
            map(([originalSource]) => originalSource), // discard enabled
          );
  }
}
